<template>
    <p class="posi-relative textarea-container flex" :class="{textareaTip:maxlength>0}">
        <!--基础的 textarea-->
        <textarea :id='id' :value='value' :class="classCpt" :style="styleCpt" 
            :maxlength="maxlength" :placeholder="'请输入' + placeholder" :readonly="readonly" 
            @click="$emit('click')" ref="inputHandle"
            v-on="inputListeners">
		</textarea>	
		<span class="posi-absolute txt-666" v-if="maxlength>0">最多输入{{maxlength}}个字</span>
     </p>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		mounted(){
			//-- 如果设定了样式
			if(this.styleCpt){ 
				this.styleOver = this.styleCpt;
			} 
			//如果有初始值
			if(this.initVal){
				this.value = this.initVal;
			}
		},
        props:['id','styleCpt','classCpt','placeholder','readonly','initVal','maxlength'],
		data(){
			return{
				typeOver:'text', //-- 默认输入框为 文本框
				value:'',
				styleOver:'', //-- 样式
				mouseeheel:'', //-- 禁止滑轮滚动
				isFocus:false, //-- 是否获得焦点
				isClear:false, //-- 是否显示删除
			}
		},
		computed:{
			inputListeners:function(){
				let vm = this;
				//Object.assign 将所有的对象合并为一个新对象
				return Object.assign(
					{},
					// 我们从父级添加所有的监听器
					this.$listeners,
					//然后我们添加定义监听器，或覆写一些监听器行为
					{
						// 这里确保组件配合 `v-model` 的工作
				        input: (event) => {
							vm.$emit('input', event.target.value)
							vm.value = event.target.value;
				        },
				        //获得焦点事件
				        onfocus: () => { vm.$emit('onfocus') },
				        //失去焦点事件
				        onblur: () => { vm.$emit('onblur') },
					}
				)
			}
		},
		watch:{
			value(newVal,oldVal){			 
				newVal = this.$tools.noEmoji(newVal);
				if(this.maxlength > 0 && newVal.length > this.maxlength){
					this.value = oldVal;
				}
			}
		},
		methods: {
			//-- 一键清除 input 的值
			clearInput(){
				this.value = ''; 
				//-- 清除后 并 获得焦点
				this.$refs.inputHandle.focus()
			},
			//-- 禁止滚轮滚动事件（结合type="number"使用）
			stopScrollFun(evt) {   
				return false;  
			},
			setValue(val){
				this.value = val;
			}
		},
	}
</script>

<style scoped lang="less">
	.textarea-container{
		textarea{
			flex: 1;
			height:4.5rem;
			padding:.5rem;
			resize: none;
			font-size:0.7rem;
		}
		span{
			left:0;
			bottom:-.1rem;

		} 
	}
	.textareaTip{
		padding-bottom:1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/textareaBase.vue